import styled, { css, keyframes } from 'styled-components';
import { AnimationType } from './index';

// Keyframe animations
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const scaleUp = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const rotateIn = keyframes`
  from {
    opacity: 0;
    transform: rotate(-10deg) scale(0.9);
  }
  to {
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
`;

const bounceIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

// Animation mapping
const animationMap = {
  fadeIn,
  slideUp,
  slideDown,
  slideLeft,
  slideRight,
  scaleUp,
  rotateIn,
  bounceIn
};

interface AnimatedContainerProps {
  $isVisible: boolean;
  $animation: AnimationType;
  $duration: number;
}

export const AnimatedContainer = styled.div<AnimatedContainerProps>`
  opacity: 0;
  transition: all ${props => props.$duration}s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  
  ${props => props.$isVisible && css`
    animation: ${animationMap[props.$animation]} ${props.$duration}s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  `}

  /* Ensure smooth performance */
  will-change: transform, opacity;
  backface-visibility: hidden;
  perspective: 1000px;
`;
